import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import BlockedSessionsTrendCard from './widgets/BlockedSessionsTrendCard/BlockedSessionsTrendCard';
import AllowedSessionsTrendCard from './widgets/AllowedSessionsTrendCard/AllowedSessionsTrendCard';
import CriticalThreatsBlockedCard from './widgets/CriticalThreatsBlockedCard/CriticalThreatsBlockedCard';
import { BlockedThreatsBySeverityWidget } from './widgets/BlockedThreatsBySeverityWidget/BlockedThreatsBySeverityWidget';
import { BlockedSessionsByTypeWidget } from './widgets/BlockedSessionsByTypeWidget/BlockedSessionsByTypeWidget';
import { TopCountriesBlockedTrafficWidget } from './widgets/TopCountriesBlockedTrafficWidget/TopCountriesBlockedTrafficWidget';
import { NetworkTrafficWidget } from './widgets/NetworkTrafficWidget/NetworkTrafficWidget';
import { TopCountriesAllowedTrafficWidget } from './widgets/TopCountriesAllowedTrafficWidget/TopCountriesAllowedTrafficWidget';
import { Direction } from '@src/utils/enums';
import { useStores } from '@src/components/store';
import './ExecutiveSummary.scss';
import { ExportReport } from '@src/components/features/reports-and-logs/new-reports/export-report';
import {ReportSubscriptionButton} from '@src/components/features/reports-and-logs/new-reports/report-subscription-button';

interface ExecutiveSummaryProps {
  fromDate: number;
  toDate: number;
}

const ExecutiveSummary: FC<ExecutiveSummaryProps> = observer(({ fromDate, toDate }) => {

  const { userStore, customerStore } = useStores();

  const { customerId, serviceId, isPremium } = customerStore;

  const baseWidgetProps = { fromDate, toDate, customerId, serviceId };

  return (
    <div className="executive-summary">
      <div className="executive-summary-header">
        <div className="executive-summary-title">Executive Summary</div>
        <div className="controls-container">
          {
            userStore.isReportSubscriptionAllowed && <ReportSubscriptionButton />
          }
          <ExportReport reportName={'executiveSummary'} isLoading={false}
                        contentClass={'executive-summary'} orientation={'p'} />
        </div>
      </div>
      <div className="executive-summary-widgets">
        <div className="widgets-row first-row">
          <BlockedSessionsTrendCard {...baseWidgetProps} />
          <AllowedSessionsTrendCard {...baseWidgetProps} />
          <CriticalThreatsBlockedCard {...baseWidgetProps} />
        </div>
        {isPremium && <div className="widgets-row">
          <BlockedThreatsBySeverityWidget {...baseWidgetProps} />
        </div>}
        <div className="widgets-row">
          <BlockedSessionsByTypeWidget {...baseWidgetProps} />
        </div>
        <div className="widgets-row">
          <TopCountriesBlockedTrafficWidget {...baseWidgetProps} />
        </div>
        <div className="widgets-row">
          <NetworkTrafficWidget {...baseWidgetProps} direction={Direction.Inbound} />
          <NetworkTrafficWidget {...baseWidgetProps} direction={Direction.Outbound} />
        </div>
        <div className="widgets-row">
          <TopCountriesAllowedTrafficWidget {...baseWidgetProps} />
        </div>
      </div>
    </div>
  );
});

export default ExecutiveSummary;
